// import { registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import en from '@angular/common/locales/en';
import { RouterModule } from '@angular/router';
// import { SafePipe } from '../pipes/safe.pipe';

// registerLocaleData(en);

@NgModule({
	// declarations: [SafePipe],
	exports: [
		// SafePipe,
		//NOTE:: Some of these need to be applied in app.config.ts.
		//Angular
		CommonModule,
		//BrowserModule,
		// AppRoutingModule,
		RouterModule,
		ReactiveFormsModule,
		// AngularFireModule.initializeApp(firebaseConfig),
		// AngularFirestoreModule, // firestore
		// AngularFireAuthModule, // auth
		// AngularFireStorageModule,
		FormsModule,
		// HttpClientModule,
		//BrowserAnimationsModule,
	],
})
export class AngularModule {}
